// Site-wide theme system — admin picks the theme in Settings, everyone sees it.
export const THEMES = [
  {
    id: "obsidian-gold",
    name: "Obsidian Gold",
    desc: "Signature black & champagne gold",
    swatches: ["#050507", "#0C0D12", "#D4AF37", "#F3E5AB"],
  },
  {
    id: "emerald",
    name: "Royal Emerald",
    desc: "Deep emerald luxury — rich green accents",
    swatches: ["#04110C", "#081D15", "#10B981", "#A7F3D0"],
  },
  {
    id: "tortoise-teal",
    name: "Tortoise Teal",
    desc: "Deep lagoon teal on near-black — icy aqua highlights",
    swatches: ["#0B1114", "#111C21", "#02AFBA", "#B8F7FA"],
  },
];

export const applyTheme = (t) => {
  const root = document.documentElement;
  if (!t || t === "obsidian-gold") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", t);
  try {
    localStorage.setItem("bk_theme", t || "obsidian-gold");
  } catch {}
};
